import React from "react";
import FAQ from "@/components/Common/FAQ";
import { createClient } from "../../../../../prismicio";
import Metadata from "@/components/Metadata";
import LayoutVariant from "@/components/LayoutVariant";
import SchemaScript from "@/components/SchemaScript";
import SingleSubPage from "@/components/watch-buyers-nyc/single-sub-page";

const SellDiamondsSub = ({ uid, globals, pageData, common }) => {
  const commonComponents = globals?.data;

  const components = {
    faqs: FAQ,
  };

  return (
    <LayoutVariant data={commonComponents}>
      <SchemaScript data={pageData?.schema_json} />
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path={`/what-we-buy/watch-buyers-nyc/${uid}`}
      />
      <SingleSubPage
        pageData={pageData}
        components={components}
        common={common}
        showBrandWeBuy={false}
      />
    </LayoutVariant>
  );
};

export default SellDiamondsSub;

export async function getStaticProps({ params, previewData }) {
  const client = createClient({ previewData });

  const page = await client.getByUID("sell_diamonds_sub", params.uid);
  const globals = await client.getSingle("globals");
  const common = await client.getSingle("common");

  return {
    props: {
      uid: params.uid,
      pageData: page?.data,
      globals,
      common,
    },
  };
}

export async function getStaticPaths() {
  const client = createClient();
  const pages = await client.getAllByType("sell_diamonds_sub");
  const paths = pages.map((page) => {
    return { params: { uid: page?.uid } };
  });
  return {
    paths,
    fallback: false,
  };
}
